import { useQueryGoalsCreatorsAndModifiers } from 'modules/goals/lib/hooks/useQueryGoalsCreatorsAndModifiers';
import { PropsWithChildren } from 'react';
import { useGoalsFilters } from '../../hooks/useGoalsFilters';
import { GoalsContext } from './GoalsContext';
import { MOCK_GOALS } from 'modules/goals/constants';

export const GoalsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const {
    clearFilters,
    creators,
    setCreators,
    modifiers,
    setModifiers,
    states,
    setStates,
    searchQuery,
    setSearchQuery,
    status,
    setStatus,
  } = useGoalsFilters();

  const creatorAndModifiers = useQueryGoalsCreatorsAndModifiers();

  const selectedFiltersCount = creators.length + modifiers.length + states.length;

  return (
    <GoalsContext.Provider
      value={{
        // TODO: setup to work with goals query
        isLoading: false,
        hasErrors: false,
        goals: MOCK_GOALS,
        selectedFiltersCount,
        clearFilters,
        creators,
        setCreators,
        modifiers,
        setModifiers,
        states,
        setStates,
        searchQuery,
        setSearchQuery,
        status,
        setStatus,
        creatorAndModifiers,
      }}
    >
      {children}
    </GoalsContext.Provider>
  );
};
